export const openFileInNewTab = (file: Blob | MediaSource) => {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.target = "_blank";
  link.click();
};

export const handleOpenPdfReport = async (pdfUrl: string) => {
  const request = await fetch(pdfUrl);
  const pdfBuffer = new Blob([await request.blob()], {
    type: "application/pdf",
  });

  openFileInNewTab(pdfBuffer);
};

export const openFileInNewTabPractice = (file: Blob | MediaSource, name: string, patient: string) => {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.download = `${patient}(${name})`;
  link.click();
};

export const handleOpenPdfReportPractice = async (pdfUrl: string, name: string, patient: string) => {
  const request = await fetch(pdfUrl);
  const pdfBuffer = new Blob([await request.blob()], {
    type: "application/pdf",
  });

  openFileInNewTabPractice(pdfBuffer, name, patient);
};